import { Check } from 'lucide-react';
import { cn } from '@/lib/cn';

/** Paleta fixa de cores fortes (dark o suficiente p/ glifo branco AA). */
export const SWATCH_COLORS = [
  '#F44336', // vermelho
  '#E91E63', // rosa
  '#9C27B0', // roxo
  '#6515DD', // roxo global
  '#2979FF', // azul
  '#00796B', // teal de cartões
  '#4CAF50', // verde
  '#FF9800', // laranja
  '#795548', // marrom
  '#607D8B', // ardósia
] as const;

interface ColorSwatchesProps {
  value: string;
  onChange: (color: string) => void;
  className?: string;
}

/** Grade de bolinhas de cor selecionáveis. A cor atual recebe anel + ✓. */
export function ColorSwatches({ value, onChange, className }: ColorSwatchesProps) {
  const normalized = value.toLowerCase();

  return (
    <div className={cn('flex flex-wrap gap-3', className)} role="radiogroup" aria-label="Cor">
      {SWATCH_COLORS.map((color) => {
        const selected = color.toLowerCase() === normalized;
        return (
          <button
            key={color}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-label={`Cor ${color}`}
            onClick={() => onChange(color)}
            className={cn(
              'grid size-9 place-items-center rounded-full text-white transition-transform hover:scale-105',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40',
              selected && 'ring-2 ring-ink ring-offset-2 ring-offset-surface',
            )}
            style={{ backgroundColor: color }}
          >
            {selected && <Check className="size-4" strokeWidth={3} />}
          </button>
        );
      })}
    </div>
  );
}
